import React, { FC } from "react";
import { LuPencil, LuSearch } from "react-icons/lu";

type Props = {
  variant: "empty" | "noResults";
  emptyDescription: string;
};

export const NoteEmptyState: FC<Props> = ({ variant, emptyDescription }) => {
  if (variant === "noResults") {
    return (
      <div
        className={
          "flex flex-col items-center justify-center gap-3 rounded-xl border border-[#E8E8EC] bg-white px-6 py-14 text-center"
        }>
        <span
          className={
            "inline-flex h-[52px] w-[52px] items-center justify-center rounded-full bg-[#F1EEFC] text-[#8A73F0]"
          }>
          <LuSearch size={24} strokeWidth={1.9} />
        </span>
        <span className={"text-[15px] font-bold text-[#3A4256]"}>
          No matching notes
        </span>
      </div>
    );
  }

  return (
    <div
      className={
        "flex flex-col items-center justify-center gap-3.5 rounded-xl border border-[#E8E8EC] bg-white px-6 py-16 text-center"
      }>
      <span
        className={
          "inline-flex h-[58px] w-[58px] items-center justify-center rounded-full bg-[#F1EEFC] text-[#8A73F0]"
        }>
        <LuPencil size={28} strokeWidth={1.7} />
      </span>
      <span className={"flex flex-col gap-[5px]"}>
        <span className={"text-base font-bold text-[#3A4256]"}>
          No notes yet
        </span>
        <span
          className={
            "max-w-[320px] text-[13px] font-medium leading-[1.5] text-[#8A92A3]"
          }>
          {emptyDescription}
        </span>
      </span>
    </div>
  );
};
